/**
 * ComplianceConfigPage - Compliance configuration dashboard
 *
 * Surfaces the ComplianceConfigurationDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides configuration of compliance thresholds, HIPAA/FDA/GDPR/SOX settings.
 *
 * Route: /admin/compliance-config
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconChecklist } from '@tabler/icons-react';

import { ComplianceConfigurationDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ComplianceConfigPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="red">
            <IconChecklist size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Compliance Configuration</Title>
            <Text size="sm" c="dimmed">
              Configure compliance thresholds and regulatory framework settings
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ComplianceConfigurationDashboard tenant={tenant?.id ?? ''} />
    </Container>
  );
}

export default ComplianceConfigPage;
